export const biddingOutcomes = [
  'won',
  'lost',
  'lowest-but-lost',
  'in-progress',
] as const

export type BiddingOutcome = (typeof biddingOutcomes)[number]

export type QuotesSummaryResult = {
  _id: string
  name: string
  quoted: number
  tendered: number
}

export type CHRManualOverridesResult = {
  _id: string
  accountId: string
  company: string
  rep: string
  repEmail: string
  sum: number
  loadIds: string[]
}

export type QuotesAdvancedBiddingResult = {
  value: string // loadId
  _id: string
  createDate: string
  pickupDate: string
  latestQuoteDate: string
  company: string
  accountId: string
  ccode: string
  winningBid: number
  chrBid: number
  lowestCompetitorBid?: number
  winningProvider: string
  rebids: number
  won: boolean
  count: number
  awardedVsChrDiff?: number
  outcome: BiddingOutcome
}
